import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { getMessaging, getToken, onMessage, isSupported, Messaging } from 'firebase/messaging';

const firebaseConfig = {
	apiKey: 'AIzaSyDwZNQZ3a8RK4kKKBGnXiL09N71UMZanOc',
	authDomain: 'dopi-live-expert.firebaseapp.com',
	projectId: 'dopi-live-expert',
	storageBucket: 'dopi-live-expert.firebasestorage.app',
	messagingSenderId: '2567664024',
	appId: '1:2567664024:web:dbff58b8f99c6817927bed',
	measurementId: 'G-9842CFRMQT'
};

const app = initializeApp(firebaseConfig);

const messaging: Messaging | null = null;

const analytics = getAnalytics(app);

export const initMessaging = async (): Promise<{
	messaging: Messaging | null;
	supported: boolean;
}> => {
	const supported = await isSupported();
	if (supported) {
		const messaging = getMessaging(app);
		return { messaging, supported };
	}
	return { messaging: null, supported: false };
};

export { messaging, getToken, onMessage, analytics };
